import apiEndpoints from '../../../api';
import { clean, url, listParams, bodyOf, getReq, writeReq } from './vmsHttp';

export const getPreApprovalsListReq = (action) => {
    const d = action.data;
    return getReq(apiEndpoints.SOCIETY_GET_PRE_APPROVALS_LIST_API, listParams(d, {
        status: d?.status,
        flat_id: d?.flatId,
    }), 'Failed to load pre-approvals');
};

export const getPreApprovalDetailsReq = (action) =>
    getReq(url(apiEndpoints.SOCIETY_GET_PRE_APPROVAL_DETAILS_API, { id: action.data.id }),
        undefined, 'Failed to load pre-approval');

// visitor_phone is the match key at the gate — the visit flow looks up
// (visitor_phone, flat_id, society_id), not visitor_id.
export const createPreApprovalReq = (action) =>
    writeReq('post', apiEndpoints.SOCIETY_CREATE_PRE_APPROVAL_API, clean(bodyOf(action.data)),
        'Pre-approval created', 'Failed to create pre-approval');

// flat_id, wing_id, visitor_id and society_id are rejected on update — a
// pre-approval cannot be moved to another flat or society.
export const updatePreApprovalReq = (action) =>
    writeReq('put', url(apiEndpoints.SOCIETY_UPDATE_PRE_APPROVAL_API, { id: action.data.id }),
        bodyOf(action.data, ['flat_id', 'wing_id', 'visitor_id', 'society_id']),
        'Pre-approval updated', 'Failed to update pre-approval');

export const deletePreApprovalReq = (action) =>
    writeReq('delete', url(apiEndpoints.SOCIETY_DELETE_PRE_APPROVAL_API, { id: action.data.id }),
        undefined, 'Pre-approval cancelled', 'Failed to cancel pre-approval');
